import type { AdminRole } from '@sbc/domain-models/admin';

export const CS_HOME = '/inbox';

export const ROLE_LABELS: Record<AdminRole, string> = {
  admin: 'Admin',
  cs: 'CS (inbox and draft review)',
};

const CS_SECTIONS = [CS_HOME, '/review'];

export function canAccessPath(role: AdminRole, pathname: string): boolean {
  if (role === 'admin') {
    return true;
  }
  return CS_SECTIONS.some((section) => pathname === section || pathname.startsWith(`${section}/`));
}
